import { Component } from "react"
import axios from "axios";
import { Row, Col, Typography, Modal, List, Space, Card, message } from 'antd';

const { Text } = Typography

class ModalSelectAddress extends Component {

    constructor(props) {
        super(props);
        this.state = {
            addresses: {
                data: [],
                limit: 11,
                page: 1,
                total: 0,
                pages: 0,
                filters: []
            },
            loading: false
        };
    }

    get = async () => {
        axios.get('/direcciones', {
            params: {
                limit: 200,

                zipcode: this.props.zipcode,
                cliente_id: this.props.cliente_id
            }
        }).then(({ data }) => {
            console.log("data", data);
            this.setState({
                addresses: {
                    ...this.state.addresses,
                    data: data.data,
                    total: data.total,
                    pages: data.pages
                }
            })
        })
    }

    componentDidMount() {
        this.get()
    }

    render() {
        return (
            <Row>
                <Col span={24}>
                    <List>
                        {this.state.addresses.data.map(address => (
                            
                            <List.Item key={address.id}>
                                <Card hoverable onClick={async () => { 
                                    let clipboard = `${this.props.client.nombre_completo ?? ""} - 📞 ${this.props.client.telefono}` +
                                        `\n 🚚 ${address.localizacion?.place_name} ${address.especificaciones ? `\n 🏢 ${address.especificaciones}` : ""} ${address.notas ? `\n 📝 ${address.notas}` : ""}` +
                                        `\n 💵 ${this.props.total.toMoney(true)} USD  👟 ${this.props.pairs} Pairs`

                                        await navigator.clipboard.writeText(clipboard)
                                        message.success('Address copied to clipboard')
                                        this.props.onClose()
                                 }}>
                                    <Space direction='vertical' size={5}>
                                    {
                                       <Text>
                                           {address.localizacion?.place_name}
                                       </Text>
                                    }
                                    
                                    {/* <Button type='primary' onClick={async () => {



                                        let clipboard = `${client.nombre ?? ""} ${client.apellidos ?? ""} \n 🚚 ${item.localizacion?.place_name} ${item.especificaciones ? `\n 🗒️ ${item.especificaciones}` : ""} \n 📞 ${client.telefono}`

                                        await navigator.clipboard.writeText(clipboard)
                                        message.success('Address copied to clipboard')
                                    }}>Copy format</Button> */}
                                </Space>
                                </Card>
                                
                            </List.Item>
                        ))}
                    </List>
                </Col>
            </Row>
        );
    }
}

export default function View(props) {

    const { visible = false, onClose = () => { }} = props

    return <Modal
        open={visible}
        onCancel={onClose}
        title={"Select an address to copy"}
        destroyOnClose={true}
        cancelText="Cancel"
        okText="Return"
    >
        <ModalSelectAddress {...props} />
    </Modal>

}